export const environment = {
  production: true,
  
  // serverUrl: 'https://api.mazayaoffers.ae/api',//production
  // nodeReportServerUrl: 'https://reports.mazayaoffers.ae/api',
  // blobUrl: 'https://offersprdsa01.blob.core.windows.net/documents/',
  // nodeServerUrl: 'https://vouchers.mazayaoffers.ae/api/v1',


  serverUrl: 'https://mazaya-api.gewaninfotech.com/api',
  nodeServerUrl: 'https://mazayabackendapi.gewaninfotech.com/api/v1',
  nodeReportServerUrl: 'https://mazaya-reports.gewaninfotech.com/api',
  blobUrl: 'https://offersuatsa01.blob.core.windows.net/documents/',

  socketUrl: 'https://mazaya-api.gewaninfotech.com',
  clientUrl: 'https://mazaya-api.gewaninfotech.com',
  useSSO: false,
  instrumentationKey: null,
  defaultLanguage: 'en-US',
};

